<template>
  <div id="checkout">
    <header class="checkout-header">
      <div class="container">
        <div class="row">
          <div class="col-md col-5 logo align-self-center">
            <b-link :href="lastSiteUrl">
              <img
                src="/app/themes/jeroboams-2020/resources/assets/images/logo@1x.svg"
                alt="Jeroboams Logo"
              />
            </b-link>
          </div>
          <div class="col text-right text-md-center align-self-center">
            <h1 class="m-0">
              <svg
                class="bi"
                style="vertical-align: text-top"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#lock"
                />
              </svg>
              Secure Bill Payment
            </h1>
            <b-link :href="lastSiteUrl" class="d-md-none"> Exit </b-link>
          </div>
          <div class="col text-right align-self-center d-none d-md-block">
            <b-link :href="lastSiteUrl"> Return to Jeroboams... </b-link>
          </div>
        </div>
      </div>
    </header>
    <div
      class="checkout-progress-wrapper"
      v-if="is_ready('address_book') || $store.state.user.is_guest"
    ></div>
    <div
      class="loading-state text-center my-4"
      v-if="!is_ready('address_book') && !$store.state.user.is_guest"
    >
      <p>Loading your address details...</p>

      <b-spinner style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <div v-else class="container">
      <div class="row">
        <div class="col-12 pt-2 checkout-typography">
          <bill-pay-summary></bill-pay-summary>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BillPaySummary from "@/views/billpay/BillPaySummary";

export default {
  data() {
    return {};
  },
  props: {
    mode: {
      type: String,
      default: "billpay",
    },
  },
  mounted() {
    this.$store.dispatch("basket/refresh_state").then((response) => {
      this.$store.commit("readiness/is_ready", "basket");
      this.$store.commit("checkout/set_order_data", response.state.order_data);
    });

    this.$store.commit("checkout/set_mode", this.mode);

    if (!this.$store.state.user.is_guest) {
      this.$store.dispatch("user/load_address_book");
    }
  },
  computed: {
    ...mapGetters("readiness", ["is_ready"]),
    checkout() {
      return this.$store.state.checkout;
    },
  },
  watch: {},
  components: {
    BillPaySummary,
  },
};
</script>